import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MetricsBarContainer = styled(Grid)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  border: '1px solid',
  borderColor: theme.palette.text.fifth,
  backgroundColor: theme.palette.background.contrast,
  borderRadius: theme.spacing(5),
}));

export const MetricItem = styled(Grid)<{ singleRowOnMobile?: boolean }>(
  ({ theme, singleRowOnMobile }) => ({
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),

    [theme.breakpoints.up('md')]: {
      '&:not(:first-child)': {
        borderLeft: '1px solid',
        borderColor: theme.palette.text.fifth,
      },
    },

    [theme.breakpoints.down('md')]: {
      ...(singleRowOnMobile
        ? {
            '&:not(:last-child)': {
              borderRight: '1px solid',
              borderColor: theme.palette.text.fifth,
            },
            [theme.breakpoints.down('sm')]: {
              padding: theme.spacing(2),
            },
          }
        : {
            minWidth: '150px',
            '&:nth-child(-n+2)': {
              borderBottom: '1px solid',
              borderColor: theme.palette.text.fifth,
            },
            '&:nth-child(odd)': {
              borderRight: '1px solid',
              borderColor: theme.palette.text.fifth,
            },
          }),
    },
  }),
);
